// @ core
const apiURLBuilder = require('core/apiURLBuilder');
// @ helpers
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const {
    ACCOUNT_WARNING_MESSAGE_REQUEST_IN_PROGRESS,
    ACCOUNT_WARNING_MESSAGE_REQUEST_SUCCESS,
    ACCOUNT_WARNING_MESSAGE_REQUEST_FAILURE,
} = require('constants/contactCenter/actionTypes');

const requestAccountWarningMessageInProgress = () => ({
    type: ACCOUNT_WARNING_MESSAGE_REQUEST_IN_PROGRESS,
});

const requestAccountWarningMessageSuccess = data => ({
    type: ACCOUNT_WARNING_MESSAGE_REQUEST_SUCCESS,
    payload: {
        data
    },
});

const requestAccountWarningMessageFailure = error => ({
    type: ACCOUNT_WARNING_MESSAGE_REQUEST_FAILURE,
    payload: {
        error,
    },
});

const requestAccountWarningMessage = (digitoControl, numeroCuenta, producto, numeroContrato) => dispatch => {
    dispatch(requestAccountWarningMessageInProgress());

    const requestData = {
        query: {
            digitoControl,
            numeroCuenta,
            producto,
            numeroContrato,
        }
    };

    APIGet(dispatch, apiURLBuilder.getURL('cuentasSaldos'), requestData)
    .then(response => {
        const accountHasWarning = (response.existenAvisos === 'SI');
        dispatch(requestAccountWarningMessageSuccess({
            accountHasWarning
        }));
    })
    .catch(error => dispatch(requestAccountWarningMessageFailure(error)));
}

module.exports = {
    requestAccountWarningMessage,
}
